export const BASE_URL = 'https://appmaterai.hartsimagineering.com/api/';
